import dayjs from "dayjs";
import ApiCall from "utils/ApiCall";

// const route = `${process.env.REACT_APP_API}/api/users`;

const getRoomReadys = async (query?: string, bookingFilter?: any) => {
  try {
    const route = `${process.env.REACT_APP_API}/wfrrecords/records${query || ''}`
    // console.log("calling to api:", route)
    const waitForRoomRecords = await ApiCall.get(route);
    // console.log({waitForRoomRecords})

    return waitForRoomRecords || []
  } catch (err) {
    throw err
  }
};

const sendRoomReadyNotificationEmail = async (data: any) => {
  // console.log({data})
  return await ApiCall.replace(
    `${process.env.REACT_APP_API}/wfrrecords/records/${data._id}`,
    data,
  );
};

const createRoomReady = async (data: any) => {
  try {
    // console.log({ data })
    return await ApiCall.post(
      `${process.env.REACT_APP_API}/wfrrecords/records`,
      {
        ...data,
      },
    );
  } catch (err) {
    console.error("createRoomReady err:", err)
    throw err
  }
};

const updateRoomReady = async (data: any) => {
  try {
    // console.log({data})
    if (!data._id)
      throw new Error("room ready data missing id")

    delete data.comments
    await ApiCall.replace(
      `${process.env.REACT_APP_API}/wfrrecords/booking`,
      data,
    );
  } catch (err) {
    throw err
  }
};

const deleteRoomReady = async (id: number) => {
  return await ApiCall.delete(`${process.env.REACT_APP_API}/wfrrecords/records/${id}`);
};

export {
  getRoomReadys,
  sendRoomReadyNotificationEmail,
  updateRoomReady,
  createRoomReady,
  deleteRoomReady,
};
